import { createSelector } from '@/shared/lib/helpers/create-store-logic';

import { selectToast } from '../slice/toast.slice';

export const [useToasts] = createSelector(selectToast.selectAll);
